module.exports = __webpack_public_path__ + "static/img/MyOne.ef4622c6.png";